import Vue from 'vue'
import VueRouter from 'vue-router'
import sip from '../views/sip/index.vue'
import yszc from '../views/app/yszc.vue'
import yhxy from '../views/app/yhxy.vue'
import dxtg from '../views/app/dxtg.vue'

Vue.use(VueRouter)


const routes = [
  // {
  //   path: '/index',
  //   name: 'index',
  //   component: sip
  // },
  // {
  //   path: '/yszc',
  //   name: 'yszc',
  //   component: yszc
  // },
  // {
  //   path: '/yhxy',
  //   name: 'yhxy',
  //   component: yhxy
  // },
  {
    path: '/',
    name: 'dxtg',
    component: dxtg
  },
  {
    path: '*',
    component: dxtg
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
